import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { makePhotoUrl } from '../../utils/makePhotoUrl';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';
import { filterByTypename } from '../../utils/graphql';
import useBasePageQuery from '../../hooks/useBasePageQuery';

const TeamsHelmet: FunctionComponent = () => {
  const basePageData = useBasePageQuery();
  const { currentUrl } = useNotNullableContext(PageMetaContext);
  const { t } = useTranslation('common', { useSuspense: false });

  if (!basePageData.data?.page) {
    return null;
  }

  const { title, relationships, hero } = basePageData.data.page;

  const beneficiaries = relationships?.beneficiaries;
  const charities = filterByTypename(beneficiaries?.nodes ?? [], 'Charity');

  return (
    <Helmet
      title={t(
        'team.titleExtra',
        '{{ teamName }} fundraising for {{ charityName }} on JustGiving',
        {
          replace: {
            teamName: title,
            charityName:
              beneficiaries && beneficiaries.totalCount && charities[0].name,
          },
          count: (beneficiaries && beneficiaries.totalCount) || 0,
        },
      )}
      meta={[
        { property: 'og:title', content: title },
        {
          property: 'og:image',
          content:
            hero?.imageUrl ||
            makePhotoUrl('trainer-no-branding_web.jpg', 'CampaignHeroMedium'),
        },
        { property: 'og:url', content: currentUrl },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'og:site_name', content: 'Just Giving' },
      ]}
    />
  );
};

export default TeamsHelmet;
